import ModuleAnalytics from 'mfReporting/Analytics';

/**
 * simple re-export of the analytics module, allowing for mocks
 * (the promise-based alias 'mfReporting/*' can't be mocked directly) to be used in tests
 */
export default ModuleAnalytics;
